/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Trained_For_QuestionInputs */

const en_us2_onboarding_experience_trained_for_question = /** @type {(inputs: Onboarding_Experience_Trained_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For how long did you train back then?`)
};

const pt_br2_onboarding_experience_trained_for_question = /** @type {(inputs: Onboarding_Experience_Trained_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por quanto tempo você treinou na época?`)
};

const es_419_onboarding_experience_trained_for_question = /** @type {(inputs: Onboarding_Experience_Trained_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por cuánto tiempo entrenaste en esa época?`)
};

const pt_pt2_onboarding_experience_trained_for_question = /** @type {(inputs: Onboarding_Experience_Trained_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durante quanto tempo treinaste nessa altura?`)
};

const fr_fr2_onboarding_experience_trained_for_question = /** @type {(inputs: Onboarding_Experience_Trained_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de temps as-tu pratiqué à l'époque ?`)
};

const de_de2_onboarding_experience_trained_for_question = /** @type {(inputs: Onboarding_Experience_Trained_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange hast du damals trainiert?`)
};

const it_it2_onboarding_experience_trained_for_question = /** @type {(inputs: Onboarding_Experience_Trained_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per quanto tempo hai fatto pesi all'epoca?`)
};

/**
* | output |
* | --- |
* | "For how long did you train back then?" |
*
* @param {Onboarding_Experience_Trained_For_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_trained_for_question = /** @type {((inputs?: Onboarding_Experience_Trained_For_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Trained_For_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_trained_for_question(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_trained_for_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_trained_for_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_trained_for_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_trained_for_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_trained_for_question(inputs)
	return en_us2_onboarding_experience_trained_for_question(inputs)
});
export { onboarding_experience_trained_for_question as "onboarding.experience_trained_for.question" }